import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import { TranslateService } from "@app/modules/shared/services/translate/translate.service";
import { MaterialInfoService } from "@app/modules/shared/services/material/material-info.service";
import { KlAlertService } from "@app/modules/shared/services/message/alert.service";
import { DocumentTypesEnum } from "@app/modules/shared/enum/document-types.enum";

@Component({
  selector: "kl-fast-material-entry",
  templateUrl: "./fast-material-entry.component.html",
  styleUrls: ["./fast-material-entry.component.scss"],
})
export class KlFastMaterialEntryComponent implements OnInit {
  @Output() onSetForm = new EventEmitter();
  @Output() onCancelForm = new EventEmitter();
  @ViewChild("focusElement", { static: true }) private focusElement: ElementRef;
  @ViewChild("fastMaterialEntryModal", { static: true }) private modal: any;
  @Input() document_type: string;

  alertMessage: string;
  alertType: string;
  alertShow = false;
  setform: boolean;
  materialValue: string;
  materialQuantity: number;
  searchTypeValue: any;
  wijmoInput: any;
  materialDescription = "";
  allInput: any;
  findMaterialObject: any;
  searchTypeOpt = [
    {
      label: this.translateService.instant("barcode"),
      value: "barcode",
    },
    {
      label: this.translateService.instant("producer_material_code"),
      value: "producer_material_code",
    },
  ];

  constructor(
    private translateService: TranslateService,
    private projectionService: MaterialInfoService,
    private klAlertService: KlAlertService,
    private elem: ElementRef
  ) {}

  ngOnInit() {
    this.searchTypeValue = "barcode";
    this.materialQuantity = 1;
    setTimeout(() => {
      this.focusElement.nativeElement.focus(() => {
        this.setform = false;
      });
    }, 600);
    this.allInput = this.elem.nativeElement.querySelectorAll("input");
    this.wijmoInput = this.elem.nativeElement.querySelector(
      "input.wj-form-control.wj-numeric"
    );
  }

  public hide() {
    this.onCancelForm.emit();
  }

  public show() {
    this.modal.show();
  }

  keydown(e) {
    let index;
    for (let i = 0; i < this.allInput.length; i++) {
      if (e.currentTarget.tagName === "WJ-INPUT-NUMBER") {
        if (this.allInput.item(i) === this.wijmoInput) {
          index = i;
        }
      } else {
        if (this.allInput.item(i) === e.currentTarget) {
          index = i;
        }
      }
    }
    const nextIndex = index + 1;
    const maxIndex = this.allInput.length;
    const key = e.which;
    if (key === 13 || key === 9) {
      e.preventDefault();
      if (e.target.id === "search_text") {
        if (this.materialValue) {
          this.alertShow = false;
          this.materialDescription = "";
          const findObject = Object.create(null);
          findObject[this.searchTypeValue] = this.materialValue;
          this.projectionService.materialInfo(findObject, "material").subscribe(
            (response) => {
              if (response) {
                if (response.status === "ACTIVE") {
                  switch (this.document_type) {
                    case DocumentTypesEnum.PURCHASE_INVOICE:
                    case DocumentTypesEnum.PURCHASE_PRODUCER_INVOICE:
                    case DocumentTypesEnum.PURCHASE_DISPATCH:
                    case DocumentTypesEnum.PURCHASE_CONSIGNMENT_DISPATCH:
                    case DocumentTypesEnum.PURCHASE_PRODUCER_DISPATCH:
                      if (response.un_purchasable === "NO") {
                        this.findMaterialObject = Object.create(null);
                        this.materialDescription = response.description;
                        this.findMaterialObject = { ...response };
                        this.setform = true;
                        if (nextIndex < maxIndex) {
                          const nextDoubleIndex = nextIndex + 1;
                          this.allInput.item(nextDoubleIndex).focus();
                        }
                        if (nextIndex === maxIndex) {
                          this.elem.nativeElement
                            .querySelector("button.setForm")
                            .focus();
                        }
                      } else {
                        this.setform = false;
                        this.focusElement.nativeElement.focus();
                        this.alertMessage = this.translateService.instant(
                          "product_is_closed_to_purchasable"
                        );
                        this.alertShow = true;
                        this.alertType = "error";
                      }
                      break;
                    case DocumentTypesEnum.SALES_RETAIL_INVOICE:
                    case DocumentTypesEnum.SALES_WHOLESALE_INVOICE:
                    case DocumentTypesEnum.SALES_RETAIL_DISPATCH:
                    case DocumentTypesEnum.SALES_WHOLESALE_DISPATCH:
                    case DocumentTypesEnum.SALES_CONSIGNMENT_DISPATCH:
                      if (response.un_saleable === "NO") {
                        this.findMaterialObject = Object.create(null);
                        this.materialDescription = response.description;
                        this.findMaterialObject = { ...response };
                        this.setform = true;
                        if (nextIndex < maxIndex) {
                          const nextDoubleIndex = nextIndex + 1;
                          this.allInput.item(nextDoubleIndex).focus();
                        }
                        if (nextIndex === maxIndex) {
                          this.elem.nativeElement
                            .querySelector("button.setForm")
                            .focus();
                        }
                      } else {
                        this.setform = false;
                        this.focusElement.nativeElement.focus();
                        this.alertMessage = this.translateService.instant(
                          "product_is_closed_to_saleable"
                        );
                        this.alertShow = true;
                        this.alertType = "error";
                      }
                      break;
                  }
                } else {
                  this.alertMessage = this.translateService.instant(
                    "product_is_closed_to_use"
                  );
                  this.alertShow = true;
                  this.alertType = "error";
                  this.focusElement.nativeElement.focus();
                  this.setform = false;
                }
              } else {
                this.alertMessage =
                  this.translateService.instant("product_not_found");
                this.alertShow = true;
                this.alertType = "error";
                this.focusElement.nativeElement.focus();
                this.setform = false;
              }
            },
            () => {
              this.alertMessage =
                this.translateService.instant("product_not_found");
              this.alertShow = true;
              this.alertType = "error";
              this.focusElement.nativeElement.focus();
              this.setform = false;
            }
          );
        } else {
          this.focusElement.nativeElement.focus();
          this.setform = false;
        }
      } else {
        if (nextIndex < maxIndex) {
          this.allInput.item(nextIndex).focus();
        }
        if (nextIndex === maxIndex) {
          this.elem.nativeElement.querySelector("button.setForm").focus();
        }
      }
    }
  }

  setForm() {
    this.alertMessage = this.translateService.instant("product_added");
    this.alertShow = true;
    this.alertType = "success";
    this.onSetForm.emit({
      response: this.findMaterialObject,
      materialQuantity: this.materialQuantity,
    });
    this.materialValue = "";
    this.materialDescription = "";
    this.searchTypeValue = "barcode";
    this.materialQuantity = 1;
    this.setform = false;
    this.focusElement.nativeElement.focus();
  }
}
